var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDoors = function SvgDoors(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4 3.39999H14.6V4.39999H18.6V19.4H21V20.6H17.4V5.59999H14.6V20.6H3V19.4H5.4V3.39999ZM6.6 19.4H13.4V4.59999H6.6V19.4ZM10.4 13V11H11.6V13H10.4Z"
  })));
};
export default SvgDoors;